import React from 'react'

import {
    STUB_TITLE,
    STUB_DESCRIPTION,
} from './constants.jsx'

import styles from './Stub.scss'

export const Stub = () => {
    return (
        <div className={styles.base}>
            <div className={styles.holder}>
                <p className={styles.title}>{STUB_TITLE}</p>
                <p className={styles.description}>{STUB_DESCRIPTION}</p>
            </div>
        </div>
    )
}

export default Stub



// WEBPACK FOOTER //
// ./containers/Stub/Stub.jsx